import React from "react";
import "./Abouthome.css";

/**
 * Props:
 *  - imageSrc (string): image shown on the right (default: /about-photo.jpeg in /public)
 *  - onReadMore (fn): optional handler for the Read more button; defaults to navigate to /about
 */
export default function Abouthome({
  imageSrc = "./emr.jpeg",
  onReadMore,
}) {
  // Fixed Read More button functionality
  const handleReadMore = () => {
    if (typeof onReadMore === "function") {
      onReadMore();
    } else {
      window.location.href = "/about";
    }
  };

  return (
    <section className="Abouthome" aria-labelledby="Abouthome-title">
      <div className="Abouthome__container">
        {/* Team Heading */}
        <div className="Abouthome__team-heading">
          <h2 id="Abouthome-title" className="Abouthome__heading">
            Meet the Team
          </h2>
          <p className="Abouthome__subheading">
            Our certified appraisers bringing expertise and precision to every assignment
          </p>
        </div>

        {/* Team Members Grid */}
        <div className="Abouthome__team-grid">
          {/* Team Member 1 - Nastasha */}
          <div className="Abouthome__team-member">
            <div className="Abouthome__member-content">
              <h3 className="Abouthome__member-name">Nastasha Waller</h3>
            <p className="Abouthome__member-title">Owner / Certified Residential Appraiser</p>
              
              <div className="Abouthome__member-bio">
                <p className="Abouthome__body">
                  I'm Nastasha, a Certified Residential Appraiser and FHA-approved professional specializing in Pierce, Grays Harbor, Thurston, King, Lewis, Kitsap, Mason, and Snohomish counties. I work with a wide range of clients from lenders and attorneys to homeowners and investors, providing appraisals for purchases, refinances, estate settlements, divorce and separation, and pre-listing appraisals. I also provide vacant land appraisals and sketching/ANSI-compliant measurements as standalone services or as part of a complete report.
                </p>

                <p className="Abouthome__body">
                  My approach is grounded in accuracy, integrity, and clear communication with every client. I stay current with industry and lending guidelines, including USPAP standards, to deliver timely, accurate, and well-supported reports. Whether you're a lender, agent, attorney, or homeowner, I tailor each assignment to your specific goal and explain the "why" behind every value conclusion.
                </p>
              </div>

              <button
                type="button"
                className="Abouthome__btn"
                onClick={handleReadMore}
                aria-label="Read more about Nastasha"
              >
                Read more
                <svg
                  className="Abouthome__btn-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>

            <div className="Abouthome__member-media">
              <div className="Abouthome__image-container">
                <img
                  className="Abouthome__img"
                  src={imageSrc}
                  alt="Nastasha Waller reviewing a residential appraisal report"
                  width={560}
                  height={370}
                  loading="lazy"
                  decoding="async"
                />
                <div className="Abouthome__image-overlay"></div>
              </div>
            </div>
          </div>

          {/* Team Member 2 - Dayton */}
          <div className="Abouthome__team-member">
            <div className="Abouthome__member-content">
              <h3 className="Abouthome__member-name">Dayton Sheasley</h3>
              <p className="Abouthome__member-title">Residential Appraiser </p>
              
              <div className="Abouthome__member-bio">
                <p className="Abouthome__body">
                My name is Dayton Sheasley, and I have been a state-licensed real estate appraiser trainee since 2023. From the moment I began appraising, I developed a genuine curiosity and appreciation for the real estate market. Its fast-paced, constantly evolving nature has provided endless opportunities for learning, growth, and professional development.
                </p>

                <p className="Abouthome__body">
                  I specialize in residential, multi-family, and vacant land appraisals across Pierce, Thurston, King, Lewis, Kitsap, and Mason counties. Every assignment presents a unique challenge, and I am committed to providing thorough, well-supported valuations as I continue to grow in the appraisal field.
                </p>
              </div>

              <button
                type="button"
                className="Abouthome__btn"
                onClick={handleReadMore}
                aria-label="Read more about Dayton"
              >
                Read more
                <svg
                  className="Abouthome__btn-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>

            <div className="Abouthome__member-media">
              <div className="Abouthome__image-container">
                <img
                  className="Abouthome__img"
                  src="./dayton.jpg"
                  alt="Dayton Sheasley conducting property analysis"
                  width={560}
                  height={370}
                  loading="lazy"
                  decoding="async"
                />
                <div className="Abouthome__image-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}